import { render, staticRenderFns } from "./CSVImport.vue?vue&type=template&id=85a0e4b2&scoped=true&"
import script from "./CSVImport.vue?vue&type=script&lang=js&"
export * from "./CSVImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a0e4b2",
  null
  
)

export default component.exports